/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAwsCustomLensRiskRule {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAwsCustomLensRiskRule.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAwsCustomLensRiskRule>): WellArchitectedFrameworkAwsCustomLensRiskRule {
        let obj = Object.assign(new WellArchitectedFrameworkAwsCustomLensRiskRule(), model);
        WellArchitectedFrameworkAwsCustomLensRiskRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAwsCustomLensRiskRule>): WellArchitectedFrameworkAwsCustomLensRiskRule {
        if (!model) return null;
        return WellArchitectedFrameworkAwsCustomLensRiskRule.newInstance(<WellArchitectedFrameworkAwsCustomLensRiskRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAwsCustomLensRiskRule) {
        if (!obj) return;

        models.WellArchitectedFrameworkAwsCustomLensRiskRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAwsCustomLensRiskRule): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAwsCustomLensRiskRule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Risk rule condition for CustomLens Question
     */
    condition: string;

    /**
     * Risk for CustomLens Question
     */
    risk: models.WellArchitectedFrameworkAwsCustomLensQuestionRisk;

}
